module.exports = __webpack_public_path__ + "data/CancerData.tsv";